export default "__VITE_PUBLIC_ASSET__a063f215__"